import styled, { css } from "styled-components";

export const IconContainer = styled.span`
	display: inline-block;

	${({ $color }) =>
		$color &&
		css`
			color: ${({ theme: { colors } }) => colors[$color]};
		`}

	svg {
		display: inline-block;
		vertical-align: -0.2em;
		height: ${({ $height }) => $height || "1em"};
		width: ${({ $width }) => $width || "auto"};

		${({ $verticalAlign }) =>
			$verticalAlign &&
			css`
				vertical-align: ${$verticalAlign};
			`}

		${({ $color }) =>
			$color &&
			css`
				color: ${({ theme: { colors } }) => colors[$color]}!important;
			`}

			${({ $mirror }) =>
			$mirror &&
			css`
				transform: rotateY(180deg);
			`}

			${({ $alwaysLight }) => css`
			color: ${({ theme: { colors, colorsDefaults } }) =>
				$alwaysLight ? colorsDefaults.black : colors.black};
		`}

			${({ $isActive }) =>
			$isActive &&
			css`
				color: ${({ theme: { colors, isDarkMode } }) =>
					isDarkMode
						? colors.primaryLight
						: "var(--dz-ref-color-primary400)"};
			`};
	}
`;

const Icon = ({
	className = "icon", // Important for inherit styles from parent (styled-components class).
	onClick,
	svgIconComponent,
	height,
	width,
	color,
	mirror = false,
	alwaysLight,
	verticalAlign,
	isActive,
	style,
}) => {
	const StaticImportSvgIcon = ({ svgIconComponent }) => {
		const CreateSvgIcon = svgIconComponent;
		return <CreateSvgIcon />;
	};

	return (
		<IconContainer
			className={className}
			onClick={onClick}
			$height={height}
			$width={width}
			$color={color}
			$mirror={mirror}
			$alwaysLight={alwaysLight}
			$verticalAlign={verticalAlign}
			$isActive={isActive}
			style={style}
		>
			<StaticImportSvgIcon svgIconComponent={svgIconComponent} />
		</IconContainer>
	);
};

Icon.displayName = "Icon";
Icon.Container = IconContainer;
export default Icon;
